export default defineNuxtPlugin(() => {
  const csrfToken = useCookie<string | null>('csrf_token')
  const marker = '__krbCsrfFetchWrapped__'

  if ((globalThis as any)[marker]) {
    return
  }
  ;(globalThis as any)[marker] = true

  const originalFetch = globalThis.$fetch

  globalThis.$fetch = originalFetch.create({
    onRequest({ request, options }) {
      const method = (options.method || 'GET').toString().toUpperCase()
      if (!['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
        return
      }

      const requestUrl = typeof request === 'string'
        ? request
        : (request as Request).url

      // Skip auth endpoints; Auth.js manages its own checks and state.
      if (requestUrl.includes('/api/auth') || requestUrl.includes('/auth')) {
        return
      }

      // Avoid attaching token to cross-origin requests.
      if (requestUrl.startsWith('http')) {
        try {
          const target = new URL(requestUrl)
          if (target.origin !== window.location.origin) {
            return
          }
        } catch {
          return
        }
      }

      if (!csrfToken.value) {
        return
      }

      const headers = new Headers(options.headers as HeadersInit | undefined)
      headers.set('x-csrf-token', csrfToken.value)
      options.headers = headers
    },
  })
})

